import { showToast, ToastType } from '../../toast';
import {
  readSessionStorageFlag,
  removeSessionStorageValue,
  SERVICE_FLOW_STORAGE_KEYS,
} from '../storage';

export class ServiceFlowNoDataWarning {
  constructor(element) {
    const message = element.dataset.noDataWarningLabel;
    const shouldShowToast = this._shouldShowToast();

    if (!message || !shouldShowToast) return;

    showToast({
      type: ToastType.WARNING,
      message,
      autoDismiss: 5000,
    });
  }

  _shouldShowToast() {
    const shouldShow = readSessionStorageFlag(SERVICE_FLOW_STORAGE_KEYS.NO_DATA_WARNING);
    removeSessionStorageValue(SERVICE_FLOW_STORAGE_KEYS.NO_DATA_WARNING);
    return shouldShow;
  }
}
